import React, { useEffect, useState } from "react";
import Multiselect from "multiselect-react-dropdown";
import Closeicon from "./../../../../src/assets/images/SheetClose.svg";

export default function SelectRecipient(props) {
  const {
    ref,
    placeHolder,
    options,
    selectedValues,
    _callBack,
    displayValue,
    selectionLimit,
    _patientIdCallBack,
    _patientNameCallBack,
  } = props;

  const onSelect = (selectedList) => {
    console.log(selectedList, "selectedList")
    localStorage.setItem("Selectvalue", JSON.stringify(selectedList[0]?.cartItem?.patient_name))
    // let ele = document.querySelector(".optionListContainer");
    // ele.classList.add("displayNone");
    recipientCallBack(selectedList);
    onSave(selectedList);
  };

  const onRemove = (selectedList) => {
    recipientCallBack(selectedList);
    onSave(selectedList);
  };

  const recipientCallBack = (selectedList) => {
    let names = [];
    let ids = [];

    selectedList &&
      selectedList.map((item) => {
        names.push(item.name);
        ids.push(item.id);
      });
    _patientIdCallBack(ids);
    _patientNameCallBack(names);
  };

  const onSave = (selectedList) => {
    let patientNames = [];
    let patientIds = [];
    let formatedObject = {};

    selectedList &&
      selectedList.map((cartItems, index) => {
        let name = cartItems.name;
        let uuid = cartItems.id;
        if (name !== "" && uuid !== "") {
          patientNames.push(cartItems.name);
          patientIds.push(cartItems.id);
          formatedObject = cartItems.cartItem;
        }
      });

    if (patientNames.length > 0 || patientIds.length > 0) {
      formatedObject["patient_name"] = patientNames;
      formatedObject["patient_uuid"] = patientIds;
    }

    if (Object.keys(formatedObject).length !== 0) {
      _callBack(formatedObject);
    }
  };

  return (
    <>
      {/* <small> Select Recipient</small> */}

      <Multiselect
        ref={ref}
        customCloseIcon={<img src={Closeicon} style={{ width: '25px' }} />}
        closeOnSelect={true}
        options={options}
        selectedValues={selectedValues}
        onSelect={onSelect}
        onRemove={onRemove}
        displayValue="name"
        showCheckbox={true}
        selectionLimit={selectionLimit}
        placeholder={placeHolder}
        showArrow={true}
        style={{
          inputField: {
            // To change input field position or margin
            margin: "5px",
          },
          chips: {
            // To change css chips(Selected options)
            background: "#F7F8FB",
            color: "black",
          },
          searchBox: {
            // To change search box element look
            color: "black",
          },
          optionContainer: {
            // To change css for option container
            border: "1px solid #E3EAF6",
          },
          option: {
            // To change css for dropdown options
            border: "1px solid #E3EAF6",
            background: "#E3EAF6",
            color: "#191716",
            margin: "5px",
          },
        }}
      />
    </>
  );
}
